export default {
      id: "arrow-steps-usage",
      viewBox: "0 0 19.791 8.915",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#arrow-steps",
      toString: function () {
        return this.url;
      }
    }